export default __webpack_public_path__ + "static/media/44.befeeb09.png";